"use client";

import { cn } from "@oreme/ui";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { cva } from "class-variance-authority";

interface ObservatoryStatProps extends HTMLAttributes<HTMLDivElement> {
  number: number;
  label: string;
  icon: ReactElement;
}

const observatoryStatVariants = cva(
  "flex flex-col p-3 w-auto min-w-30 h-auto min-h-20 rounded-lg overflow-hidden bg-primary-foreground outline outline-border",
);

function ObservatoryStat({
  number,
  label,
  icon,
  className,
  ...props
}: Readonly<ObservatoryStatProps>): ReactElement {
  return (
    <div className={cn(observatoryStatVariants(), className)} {...props}>
      <span className="mb-2">{icon}</span>
      <span className="text-3xl font-mono">{number}</span>
      <span className="text-sm opacity-50">{label}</span>
    </div>
  );
}

export { ObservatoryStat, type ObservatoryStatProps };
